export var avatarImageControlTheme = {
  baseStyle: _ref => {
    var {
      isViewMode,
      isLoading
    } = _ref;
    return {
      container: {
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 's'
      },
      avatar: {
        w: '120px',
        h: '120px',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        color: 'neutral.white',
        backgroundColor: 'neutral.darker',
        shadow: isViewMode ? 0 : 500,
        transition: 'shadow 0.1s ease-in-out',
        _hover: {
          cursor: isViewMode || isLoading ? 'default' : 'pointer',
          shadow: isViewMode || isLoading ? 0 : 600,
          transition: 'shadow 0.1s ease-in-out'
        },
        _active: {
          backgroundColor: isViewMode || isLoading ? 'neutral.darker' : 'neutral.darkest'
        }
      },
      image: {
        position: 'absolute'
      },
      icon: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 'dropdown'
      },
      initials: {
        textStyle: 'body1Semi'
      }
    };
  },
  variants: {
    circle: {
      avatar: {
        borderRadius: 'full'
      }
    },
    square: {
      avatar: {
        borderRadius: 'l'
      }
    }
  }
};
//# sourceMappingURL=AvatarImageControl.theme.js.map